// Auto-generated hairstyle presets - DO NOT EDIT
// Generated: 2026-02-01T15:23:48.512Z

import type { Gender } from '@/types/character';

export interface HairstylePreset {
  id: string;
  name: string;
  thumbnailUrl: string;
  prompt?: string;
}

// Female hairstyle presets
export const FEMALE_HAIRSTYLE_PRESETS: HairstylePreset[] = [
  {
    id: 'long-straight-black',
    name: 'Long Straight Black',
    thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/987c9334-4c95-4132-902d-f34772f30c38.png',
    prompt: `3D render of women's hairstyle on solid soft pink background (#FFE4E6).
        Long straight jet black hair, sleek and shiny, past shoulders.
        Side profile view of realistic hair, no face visible.
        Soft studio lighting, hair strands visible, salon quality render.`,
  },
  {
    id: 'long-straight-blonde',
    name: 'Long Straight Blonde',
    thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/afb7f4f1-8961-4ce9-946b-06a7084aa1ec.png',
    prompt: `3D render of women's hairstyle on solid soft pink background (#FFE4E6).
        Long straight platinum blonde hair, silky texture, past shoulders.
        Side profile view of realistic hair, no face visible.
        Soft studio lighting, hair strands visible, salon quality render.`,
  },
  {
    id: 'long-wavy-brown',
    name: 'Long Wavy Brown',
    thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/7084b343-57b6-46b8-ab31-a97d1615eba6.png',
    prompt: `3D render of women's hairstyle on solid soft pink background (#FFE4E6).
        Long wavy chestnut brown hair, soft beach waves, flowing.
        Side profile view of realistic hair, no face visible.
        Soft studio lighting, wave texture visible, salon quality render.`,
  },
  {
    id: 'long-wavy-red',
    name: 'Long Wavy Red',
    thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/710397bc-30f4-4ad1-88ed-c872673c375a.png',
    prompt: `3D render of women's hairstyle on solid soft pink background (#FFE4E6).
        Long wavy auburn red hair, romantic waves, flowing.
        Side profile view of realistic hair, no face visible.
        Soft studio lighting, rich red tones visible, salon quality render.`,
  },
  {
    id: 'bob-black',
    name: 'Bob Black',
    thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/70df7288-7682-4cf5-83f4-c597d412769f.png',
    prompt: `3D render of women's hairstyle on solid soft pink background (#FFE4E6).
        Classic black bob haircut, chin length, sleek.
        Side profile view of realistic hair, no face visible.
        Soft studio lighting, clean lines visible, salon quality render.`,
  },
  {
    id: 'bob-blonde',
    name: 'Bob Blonde',
    thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/7f628baa-3567-46f9-8739-bfcb605bf593.png',
    prompt: `3D render of women's hairstyle on solid soft pink background (#FFE4E6).
        Classic honey blonde bob haircut, chin length, bouncy.
        Side profile view of realistic hair, no face visible.
        Soft studio lighting, golden tones visible, salon quality render.`,
  },
  {
    id: 'pixie-brunette',
    name: 'Pixie Brunette',
    thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/2f82ad51-f851-446d-85cd-ea978cdf8baa.png',
    prompt: `3D render of women's hairstyle on solid soft pink background (#FFE4E6).
        Short brunette pixie cut, textured and modern.
        Side profile view of realistic hair, no face visible.
        Soft studio lighting, edgy style visible, salon quality render.`,
  },
  {
    id: 'ponytail-brown',
    name: 'Ponytail Brown',
    thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/52ea14ba-f95c-4171-9b29-0197267c579e.png',
    prompt: `3D render of women's hairstyle on solid soft pink background (#FFE4E6).
        High sleek brown ponytail, polished and elegant.
        Side profile view of realistic hair, no face visible.
        Soft studio lighting, smooth texture visible, salon quality render.`,
  },
  {
    id: 'curly-black',
    name: 'Curly Black',
    thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/ee798d39-a9d6-4435-9778-daa4760f816c.png',
    prompt: `3D render of women's hairstyle on solid soft pink background (#FFE4E6).
        Natural voluminous black curly hair, bouncy ringlets.
        Side profile view of realistic hair, no face visible.
        Soft studio lighting, curl definition visible, salon quality render.`,
  },
  {
    id: 'bun-brunette',
    name: 'Elegant Bun',
    thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/e5105366-10b7-49cd-87fd-421dde251af1.png',
    prompt: `3D render of women's hairstyle on solid soft pink background (#FFE4E6).
        Elegant brunette hair bun, swept up neatly at crown.
        Side profile view of realistic hair, no face visible.
        Soft studio lighting, polished updo visible, salon quality render.`,
  },
  {
    id: 'braids-black',
    name: 'Braids Black',
    thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/a2e7254b-7f3a-4559-b7c3-b24268ee86a7.png',
    prompt: `3D render of women's hairstyle on solid soft pink background (#FFE4E6).
        Long black box braids, neat and stylish.
        Side profile view of realistic hair, no face visible.
        Soft studio lighting, braid pattern visible, salon quality render.`,
  },
  {
    id: 'ombre-brown-blonde',
    name: 'Ombre Brown-Blonde',
    thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/3d394e54-4f15-49f3-8d4e-0202a57ed184.png',
    prompt: `3D render of women's hairstyle on solid soft pink background (#FFE4E6).
        Long ombre hair, dark brown roots fading to blonde tips, wavy.
        Side profile view of realistic hair, no face visible.
        Soft studio lighting, color gradient visible, salon quality render.`,
  },
];

// Male hairstyle presets
export const MALE_HAIRSTYLE_PRESETS: HairstylePreset[] = [
  {
    id: 'short-classic-black',
    name: 'Classic Black',
    thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/726f0e84-f77d-4420-8e76-4fce0bd05aec.png',
    prompt: `3D render of men's hairstyle on solid slate blue background (#6B7B8C).
        Classic short black hair, neat and professional, side part.
        Side profile view of realistic hair, no face visible.
        Soft studio lighting, clean cut visible, barber quality render.`,
  },
  {
    id: 'short-classic-brown',
    name: 'Classic Brown',
    thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/2dc29ad3-b395-4995-9e9a-4902feb544b6.png',
    prompt: `3D render of men's hairstyle on solid slate blue background (#6B7B8C).
        Classic short brown hair, neat and professional.
        Side profile view of realistic hair, no face visible.
        Soft studio lighting, natural color visible, barber quality render.`,
  },
  {
    id: 'fade-black',
    name: 'Fade Black',
    thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/2842257c-7aa7-4908-888c-ea95997a3ca6.png',
    prompt: `3D render of men's hairstyle on solid slate blue background (#6B7B8C).
        High fade black hair, short sides with textured top.
        Side profile view of realistic hair, no face visible.
        Soft studio lighting, fade gradient visible, barber quality render.`,
  },
  {
    id: 'undercut-blonde',
    name: 'Undercut Blonde',
    thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/35e72628-2509-465f-8bdc-be9b69530534.png',
    prompt: `3D render of men's hairstyle on solid slate blue background (#6B7B8C).
        Undercut with blonde styled top, dramatic contrast.
        Side profile view of realistic hair, no face visible.
        Soft studio lighting, style contrast visible, barber quality render.`,
  },
  {
    id: 'quiff-brown',
    name: 'Quiff Brown',
    thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/2a769187-cc02-4fc8-a062-e063a17bd09d.png',
    prompt: `3D render of men's hairstyle on solid slate blue background (#6B7B8C).
        Brown quiff hairstyle, volume on top swept back.
        Side profile view of realistic hair, no face visible.
        Soft studio lighting, volume visible, barber quality render.`,
  },
  {
    id: 'buzz-black',
    name: 'Buzz Cut Black',
    thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/45687f1d-7275-4dad-a8a6-2b2fb85a473e.png',
    prompt: `3D render of men's hairstyle on solid slate blue background (#6B7B8C).
        Black buzz cut, very short all over, clean.
        Side profile view of realistic hair, no face visible.
        Soft studio lighting, close crop visible, barber quality render.`,
  },
  {
    id: 'medium-textured-brown',
    name: 'Medium Textured',
    thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/6fe4ef52-96cf-4d2a-9a5e-564fa78383f2.png',
    prompt: `3D render of men's hairstyle on solid slate blue background (#6B7B8C).
        Medium length brown textured hair, messy styled look.
        Side profile view of realistic hair, no face visible.
        Soft studio lighting, texture visible, barber quality render.`,
  },
  {
    id: 'slicked-back-black',
    name: 'Slicked Back Black',
    thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/9562a715-d477-4c85-b66a-5c2ad53f8880.png',
    prompt: `3D render of men's hairstyle on solid slate blue background (#6B7B8C).
        Black slicked back hair, smooth and polished.
        Side profile view of realistic hair, no face visible.
        Soft studio lighting, sleek shine visible, barber quality render.`,
  },
  {
    id: 'curly-black',
    name: 'Curly Black',
    thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/7a5320fd-54a1-4928-b375-2e3108c97b57.png',
    prompt: `3D render of men's hairstyle on solid slate blue background (#6B7B8C).
        Short black curly hair, natural tight curls.
        Side profile view of realistic hair, no face visible.
        Soft studio lighting, curl pattern visible, barber quality render.`,
  },
  {
    id: 'pompadour-brown',
    name: 'Pompadour Brown',
    thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/af6e7024-4680-43c5-9963-b67e6e7a016a.png',
    prompt: `3D render of men's hairstyle on solid slate blue background (#6B7B8C).
        Brown pompadour hairstyle, high volume front, faded sides.
        Side profile view of realistic hair, no face visible.
        Soft studio lighting, classic style visible, barber quality render.`,
  },
  {
    id: 'man-bun-black',
    name: 'Man Bun Black',
    thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/ca63d8ba-885f-4a75-a47b-baab7d88be04.png',
    prompt: `3D render of men's hairstyle on solid slate blue background (#6B7B8C).
        Black man bun, long hair tied up at crown.
        Side profile view of realistic hair, no face visible.
        Soft studio lighting, bun shape visible, barber quality render.`,
  },
  {
    id: 'grey-distinguished',
    name: 'Grey Distinguished',
    thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/1588fd30-d242-49a2-af2e-1dfa8e873611.png',
    prompt: `3D render of men's hairstyle on solid slate blue background (#6B7B8C).
        Salt and pepper grey hair, short classic style, distinguished.
        Side profile view of realistic hair, no face visible.
        Soft studio lighting, grey tones visible, barber quality render.`,
  },
];

// Get hairstyle presets by gender
export function getHairstylePresetsByGender(gender: Gender): HairstylePreset[] {
  switch (gender) {
    case 'female':
      return FEMALE_HAIRSTYLE_PRESETS;
    case 'male':
      return MALE_HAIRSTYLE_PRESETS;
    default:
      return FEMALE_HAIRSTYLE_PRESETS;
  }
}

// Legacy export (defaults to female)
export const GENERATED_HAIRSTYLE_PRESETS = FEMALE_HAIRSTYLE_PRESETS;
